module.exports = __webpack_public_path__ + "static/media/mysta.8c5f0c35.svg";